import { loading, error, suggestions, filters } from '../state'
import { suggestionsService } from '../../../services/suggestions/suggestions-service'
import { fetchSuggestions } from './fetch-suggestions'
import { useAssetStore } from '@/stores'

/**
 * Öneriyi günceller
 * @param {Number|String} id - Öneri ID'si
 * @param {Object} suggestionData - Güncellenecek öneri verileri
 * @returns {Promise<Object|null>} Güncellenmiş öneri veya null
 */
export const updateSuggestion = async (id, suggestionData) => {
  try {
    // Store'dan assetId'yi al - Fonksiyon içinde çağırıyoruz!
    const assetStore = useAssetStore()
    const assetId = assetStore.assetId

    loading.value = true
    error.value = null

    // Her zaman assetId ekle
    suggestionData.assetId = assetId

    const response = await suggestionsService.updateSuggestion(id, suggestionData)

    if (response && response.success && response.data) {
      // Öneri listesini güncelle
      fetchSuggestions()

      // Listedeki ilgili öneriyi güncelle
      const index = suggestions.value.findIndex(s => s.id === id)
      if (index !== -1) {
        suggestions.value[index] = response.data
      }

      return response.data
    } else if (response && response.success) {
      // Data olmadan başarılı bir işlem
      // Öneri listesini yenile
      fetchSuggestions()
      return null
    } else {
      // Hata mesajını güncelle - daha güvenli kontrol ekledik
      const errorMsg = response && response.message ? response.message : 'Öneri güncellenirken bir hata oluştu'
      error.value = errorMsg
      console.error('Update failed with response:', response)
      throw new Error(errorMsg)
    }

  } catch (err) {
    console.error(`Error updating suggestion with id ${id}:`, err)
    error.value = 'Bağlantı hatası: Öneri güncellenirken bir hata oluştu'
    throw err
  } finally {
    loading.value = false
  }
}
